export default __webpack_public_path__ + "static/18_34-0a1f72c60679341c1af9962557086b88.png";